
    <mat-dialog-content>
        <p><strong>{{txt}}</strong></p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button class="yesButton buttonDialog"  (click)="Option1()">{{option1}}</button>
        <button class="noButton buttonDialog"  (click)="Option2()">{{option2}}</button>
    </mat-dialog-actions>

